// extracted by mini-css-extract-plugin
export default {"Videos":"Videos_Videos__+lMt2","videosContainer":"Videos_videosContainer__qWPWr","rotate":"Videos_rotate__sffyl","videoResponsive":"Videos_videoResponsive__uLmkF"};